module.exports = __webpack_public_path__ + "media/src/images/white-logo-ad9b60d731560c704b60684aa2ed3749.svg";